import { createAxiosInstance } from "./index";
import hostConfig from "@/config/hostResolver";

const baseUrl = process.env.VUE_APP_AUTH_URL ?? `${hostConfig.apiBaseUrl}/auth-service`;

class AuthService {
  // Lazy getter: defer createAxiosInstance until first use so we survive the
  // circular import chain services/index.js → store → AuthService → services/index.js
  // (same pattern as WhitelabelService / UserServiceV3).
  get apiClient() {
    if (!this._apiClient) {
      this._apiClient = createAxiosInstance(baseUrl);
    }
    return this._apiClient;
  }

  fetchUserPermissions() {
    return this.apiClient
      .get("/v3/user/permissions", { silent: true, timeout: 5000 })
      .then((response) => response.data);
  }

  syncRoles() {
    return this.apiClient
      .post("/v3/role/sync")
      .then((response) => {
        console.log(response.data);
        return response.data;
      })
      .catch((error) => {
        console.error("Failed to sync roles", error);
        throw error;
      });
  }

  getClientSSOSetup(clientId) {
    return this.apiClient
      .get(this.clientSSOSetupPath(clientId), { silent: true, retryRequest: false })
      .then((response) => response.data.result);
  }

  createClientSSOSetup(clientId, payload, idempotencyKey) {
    return this.postClientSSOSetupMutation(
      this.clientSSOSetupPath(clientId),
      payload,
      idempotencyKey
    );
  }

  revokeClientSSOSetupTicket(clientId, setupAttemptId, payload, idempotencyKey) {
    return this.postClientSSOSetupMutation(
      `${this.clientSSOSetupPath(clientId)}/${encodeURIComponent(setupAttemptId)}/ticket/revoke`,
      payload,
      idempotencyKey
    );
  }

  regenerateClientSSOSetupTicket(clientId, setupAttemptId, payload, idempotencyKey) {
    return this.postClientSSOSetupMutation(
      `${this.clientSSOSetupPath(clientId)}/${encodeURIComponent(
        setupAttemptId
      )}/ticket/regenerate`,
      payload,
      idempotencyKey
    );
  }

  markClientSSOSetupManuallyEnabled(clientId, setupAttemptId, payload, idempotencyKey) {
    return this.postClientSSOSetupMutation(
      `${this.clientSSOSetupPath(clientId)}/${encodeURIComponent(
        setupAttemptId
      )}/mark-manually-enabled`,
      payload,
      idempotencyKey
    );
  }

  clientSSOSetupPath(clientId) {
    return `/v3/client-sso/admin/clients/${encodeURIComponent(clientId)}/setup`;
  }

  postClientSSOSetupMutation(path, payload, idempotencyKey) {
    return this.apiClient
      .post(path, payload, {
        headers: { "Idempotency-Key": idempotencyKey },
        silent: true,
        // The user retries explicitly so the same Idempotency-Key is reused on purpose.
        retryRequest: false,
      })
      .then((response) => response.data.result);
  }
}

export default new AuthService();
